import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import { AsideSection } from '../AsideSection'
import { MedicoesCard } from './MedicoesCard'

export interface MedicoesSectionProps {
  prontuarioId: ID
  dataAtendimento: Instant
}

export function MedicoesSection(props: MedicoesSectionProps) {
  const history = useHistory()
  const match = useRouteMatch()

  const handleClick = () => history.push(`${match.url}/historicoMedicoes`)

  return (
    <AsideSection title='Medições' tooltip='Ver histórico de medições' onClick={handleClick}>
      <MedicoesCard {...props} />
    </AsideSection>
  )
}
